// extracted by mini-css-extract-plugin
export default {"upperTextShieldRoot":"upperTextShieldRoot___Ilms2","s":"s___mlCEo","m":"m___bKnFF","l":"l___NtTZH","upperTextShieldImg":"upperTextShieldImg___q7Fn4"};